"use client";

import React, { Suspense, lazy, useState } from "react";
import type { CompareTrayProps } from "./compare-tray";
import { useIsCompareTrayOpen } from "./compare-tray-context.client";
import { withSafeRender } from "../../atoms/safe-render";

/* The tray body, its chip and both stylesheets load only after the first
   open — the source lazy-loads the same way (`dtv-plan-card-v2-module.tsx:30`).
   A chunk that fails to load (a tab restored after a deploy) renders nothing
   rather than throwing into the carousel. */
const LazyCompareTray = lazy(() => import("./compare-tray")
  .then(module => ({ default: module.CompareTray }))
  .catch(() => ({ default: () => null })));

/**
 * Mounts the Compare Tray once the tray first opens, inside a provider. Kept
 * mounted afterwards so closing and reopening does not re-suspend.
 */
function CompareTraySlotImpl(props: CompareTrayProps) {
  const trayOpen = useIsCompareTrayOpen();
  const [everOpened, setEverOpened] = useState(false);
  /* Latched during render (React's derived-state pattern) so the first open
     mounts the tray in the same pass. */
  if (trayOpen && !everOpened) {
    setEverOpened(true);
  }
  if (!everOpened && !trayOpen) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <LazyCompareTray {...props} />
    </Suspense>
  );
}
export const CompareTraySlot = withSafeRender(CompareTraySlotImpl, "CompareTraySlot");
